/*
@创建人: lfq
@创建时间: 2020-07-28 14:47:36
@文件介绍: 宏观决策优化
*/
export default [{
    path: 'macroplan',
    name: 'macroplan',
    meta: {
        title: '宏观规划管理',
        auth: true
    },
    component: () =>
        import ('@/views/macroDecisionMaking/macroplan')
},
{
    path: 'optimizeParameter',
    name: 'optimizeParameter',
    meta: {
        title: '优化参数设置',
        auth: true
    },
    component: () =>
        import ('@/views/macroDecisionMaking/optimizeParameter')
}]

